import { Component, Input, OnInit } from '@angular/core';
import { getFormattedAliasNumber } from '../../utility-classes/formatted-alias-number';

@Component({
  selector: 'app-favorite-header',
  templateUrl: './favorite-header.component.html',
  styleUrls: ['./favorite-header.component.scss', '../../../../home/home.component.scss']
})
export class FavoriteHeaderComponent implements OnInit {
  @Input() description!:string;
  @Input() iconClass!:string;
  
  constructor() { }

  ngOnInit(): void {
  }
}
